import { Chip } from "@mui/material";
import { Box } from "@mui/system";
import type { FC } from "react";
import { SHIFT_FILTER_LABELS, ShiftFilter } from "../types";

// Functional / Categorical: shift filter chip colors. Must stay stable across themes.
const SHIFT_CHIP_COLORS = {
	UNSELECTED_BG: "var(--inhouse-primary-alpha-08)",
	UNSELECTED_TEXT: "var(--inhouse-primary-light)",
} as const;

interface ShiftFilterChipsProps {
	value: ShiftFilter;
	onChange: (filter: ShiftFilter) => void;
	color: string;
}

export const ShiftFilterChips: FC<ShiftFilterChipsProps> = ({ value, onChange, color }) => (
	<Box sx={{ display: "flex", gap: 0.5 }}>
		{Object.values(ShiftFilter).map((f) => (
			<Chip
				key={f}
				label={SHIFT_FILTER_LABELS[f]}
				size="small"
				onClick={() => onChange(f)}
				sx={{
					bgcolor: value === f ? `${color}20` : SHIFT_CHIP_COLORS.UNSELECTED_BG,
					color: value === f ? color : SHIFT_CHIP_COLORS.UNSELECTED_TEXT,
					fontWeight: 600,
					fontSize: "12px",
					cursor: "pointer",
					border: value === f ? `1px solid ${color}40` : "1px solid transparent",
				}}
			/>
		))}
	</Box>
);
